import { zodResolver } from "@hookform/resolvers/zod";
import { UserContext } from "../../contexts/UserContext";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";
import {
  WithLoggedInAuthInfoProps,
  withRequiredAuthInfo,
} from "@propelauth/react";
import { useContext, useState } from "react";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { postWithToken} from "../../api/apiBase";
import { useToast } from "../ui/use-toast";

type inviteUserProps = WithLoggedInAuthInfoProps & {
  onSubmit: (user: any) => void;
};

export type tempUser = {
  name?: string;
  email: string;
};

const LoginSchema = z.object({
  email: z
    .string()
    .min(1, { message: "This field has to be filled." })
    .email("This is not a valid email."),
});

function InviteUserDialog(props: inviteUserProps) {
  const userContext = useContext(UserContext);
  const { toast } = useToast();
  const form = useForm<tempUser>({
    resolver: zodResolver(LoginSchema),
    mode: 'onSubmit'
  });

  const {isValid} = form.formState

  const handleSubmit = () => {
    if (userContext) {
      const user = form.getValues() as tempUser;

      postWithToken(`/company/${userContext?.company_id}/invite_user` ,
          JSON.stringify(user), props.accessToken)
          .then((response) => {
            props.onSubmit(user);
        }
      ).catch((err) => {
        toast({
          variant: "destructive",
          title: "Could not invite user",
          description: `${user.email} may already be a member of a company.`,
        });
      });
    }
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button>Invite Team Member</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Invite User to </DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>

        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(handleSubmit)}
            className="space-y-8"
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input placeholder="" {...field} value={field.value || ''}/>
                  </FormControl>
                  <FormDescription>Invite user by email</FormDescription>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogClose asChild>
              <Button type="submit" variant="secondary" onClick={handleSubmit} disabled={!isValid}>
                Invite User
              </Button>
            </DialogClose>
            {/*<Button type="submit">Submit</Button>*/}
          </form>
        </Form>
        <DialogFooter className="sm:justify-start"></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default withRequiredAuthInfo(InviteUserDialog);
